export default {
  vintage_timeout: {
    title: 'VINTAGE TIME-OUT PHOTOS',
    shortDescription: 'What a find! Jim Miller rescued these precious photos from the garbage and has graciously allowed me to present them to you here.',
    longDescription: 'Huge thanks to Jim Miller for rescuing these photos and allowing me to use them on my site!',
    heroImage: require('@/assets/images/albums/vintage_timeout/image (23).jpg'),
    slides: [
      { image: require('@/assets/images/albums/vintage_timeout/image (1).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (2).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (3).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (4).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (5).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (6).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (7).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (8).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (9).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (10).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (11).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (12).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (13).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (14).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (15).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (16).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (17).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (18).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (19).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (20).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (21).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (22).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (23).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (24).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (25).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (26).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (27).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (28).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (29).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (30).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (31).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (32).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (33).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (34).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (35).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (36).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (37).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (38).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (39).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (40).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (41).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (42).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (43).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (44).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (45).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (46).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (47).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (48).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (49).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (50).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (51).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (52).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (53).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (54).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (55).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (56).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (57).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (58).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (59).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (60).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (61).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (62).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (63).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (64).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (65).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (66).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (67).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (68).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (69).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (70).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (71).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (72).jpg') },
      { image: require('@/assets/images/albums/vintage_timeout/image (73).jpg') },
    ]
  },
  rainbow_centre: {
    title: 'RAINBOW CENTRE TIME-OUT',
    shortDescription: 'Tree Ghost of Jump The Falls donated this very cool collection of mementoes he has from the Time-Out that existed at the now abandoned Rainbow Centre Mall in Niagara Falls NY.',
    longDescription: 'Photos from the (now closed) Rainbow Centre Time-Out location at Niagara Falls, which first opened in 1982.<br><br>Donated by Tree Ghost of <a href="jumpthefalls.com" target="_blank">jumpthefalls.com</a>',
    heroImage: require('@/assets/images/albums/rainbow_centre/image (2).jpg'),
    slides: [
      { image: require('@/assets/images/albums/rainbow_centre/image (1).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (2).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (3).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (4).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (5).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (6).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (7).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (8).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (9).jpg') },
      { image: require('@/assets/images/albums/rainbow_centre/image (10).jpg') },
    ]
  },
  spaceport_training: {
    title: 'VINTAGE SPACEPORT PICTURES',
    shortDescription: 'Slides from a 1981 Space Port Arcade training video. Pins and Vids kindly donated a couple slides from this priceless training video and have permitted me to post them here.',
    longDescription: 'A couple slides from a 1981 Space Port training "video" (slideshow with audio).<br><br>You can purchase a DVD containing this entire video from <a href="pinsandvids.com" target="_blank">pinsandvids.com</a>.',
    heroImage: require('@/assets/images/albums/spaceport_training/image (1).jpg'),
    slides: [
      { image: require('@/assets/images/albums/spaceport_training/image (1).jpg') },
      { image: require('@/assets/images/albums/spaceport_training/image (2).jpg') },
      { image: require('@/assets/images/albums/spaceport_training/image (3).jpg') },
      { image: require('@/assets/images/albums/spaceport_training/image (4).jpg') },
      { image: require('@/assets/images/albums/spaceport_training/image (5).jpg') },
    ]
  },  
  timeout_papercade: {
    title: 'TIME-OUT "PAPERCADE"',
    shortDescription: 'Kyle Snyder has built an entire miniature Time-Out Arcade from paper!',
    longDescription: 'An entire miniature Time-Out arcade made out of paper, built and photographed by Kyle Snyder!',
    heroImage: require('@/assets/images/albums/timeout_papercade/image (10).jpg'),
    slides: [
      { image: require('@/assets/images/albums/timeout_papercade/image (1).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (2).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (3).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (4).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (5).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (6).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (7).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (8).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (9).jpg') },
      { image: require('@/assets/images/albums/timeout_papercade/image (10).jpg') },
    ]
  },  
  laurel_center_mall: {
    title: 'LAUREL CENTRE MALL',
    shortDescription: 'I can\'t remember where I got these. If you know who I should credit please let me know.',
    longDescription: 'I can\'t remember where I got these. If you know who I should credit please let me know.',
    heroImage: require('@/assets/images/albums/laurel_center_mall/album.jpg'),
    slides: [
      { image: require('@/assets/images/albums/laurel_center_mall/image (1).jpg') },
      { image: require('@/assets/images/albums/laurel_center_mall/image (2).jpg') },
      { image: require('@/assets/images/albums/laurel_center_mall/image (3).jpg') },
      { image: require('@/assets/images/albums/laurel_center_mall/image (4).jpg') },
    ]
  },  
  mark_salas: {
    title: 'MARK SALAS',
    shortDescription: 'Mark Salas sent me these cool Time-Out photos',
    longDescription: `
      Mark Salas sent me these cool Time-Out photos.<br><br>

      Mark says:
      
      <i><p>"I grew up in the D.C. suburbs and spent much of my high school youth at the Forest Village Park Mall Time-Out which was (is) in the Upper Marlboro, MD area. I also spent a lot of time at both of the Time-Outs in Springfield Mall and I used to go to the Time-Out in D.C. at the Mall.</p>
      
      <p>In 1981 I entered the Time Out Pinball Tournament to benefit United Cerebal Palsy.</p>
      
      <p>I actually won the tournament and the grand prize of a Stern Magic pinball machine.</p>
      
      <p>The following pictures are: The announcement of the pinball tournament including dates, rules etc (orange flyer), I also included the write up in the P.G. Journal with my name in the paper. Also, the frisbees that they gave away and the document I signed when the machine came to my house for set up."<p></i>
    `,
    heroImage: require('@/assets/images/albums/mark_salas/image (1).jpg'),
    slides: [
      { image: require('@/assets/images/albums/mark_salas/image (1).jpg') },
      { image: require('@/assets/images/albums/mark_salas/image (2).jpg') },
      { image: require('@/assets/images/albums/mark_salas/image (3).jpg') },
      { image: require('@/assets/images/albums/mark_salas/image (4).jpg') },
    ]
  },  
  tokens: {
    title: 'TOKENS',
    shortDescription: 'Various Time-Out tokens',
    longDescription: 'Various Time-Out tokens',
    heroImage: require('@/assets/images/albums/tokens/image (2).jpg'),
    slides: [
      { image: require('@/assets/images/albums/tokens/image (1).jpg') },
      { image: require('@/assets/images/albums/tokens/image (2).jpg') },
      { image: require('@/assets/images/albums/tokens/image (3).jpg') },
      { image: require('@/assets/images/albums/tokens/image (4).jpg') },
      { image: require('@/assets/images/albums/tokens/image (5).jpg') },
      { image: require('@/assets/images/albums/tokens/image (6).jpg') },
    ]
  },  
  goldenring: {
    title: 'TIME-OUT AT GOLDEN RING MALL',
    shortDescription: 'Gary Heller send in these photos from TIME-OUT at Golden Ring Mall in Rosedale, Maryland, just north of Baltimore.',
    longDescription: `
      <p><strong>Gary Heller sent in these photos along with the following background info:</strong></p>

      <p>This is from TIME-OUT at Golden Ring Mall in Rosedale, Maryland, just north of Baltimore.</p>
      
      <p>It's a SEGA'S Time Out design from the mid/late 80's of moderate size, probably around 4000 Sq.Ft. and was located just a couple stores away from a mall enterance. I was asked to go down there for a couple weeks and take over the store as they had just fired the manager and wanted someone to clean up the aftermath, fix up the machines and deal with a staff that included at least one thief (who i caught!). This was in late 1994 i believe.</p>
      
      <p>The store itself was closed in 1998 I think, because I remember visiting the mall around then and the arcade was now a sports memoriabilia store but still had all the TimeOut facade. The mall closed completely in 2000 and is now gone. It's a pretty ordinary location with some ticket redemption stuff, but I also got shots of the workroom which most people never see.</p>
      
      A brief mall history is here:<br>
      <a href="http://deadmalls.com/malls/golden_ring_mall.html" target="_blank">http://deadmalls.com/malls/golden_ring_mall.html</a>
    `,
    heroImage: require('@/assets/images/albums/goldenring/image (5).jpg'),
    slides: [
      { image: require('@/assets/images/albums/goldenring/image (1).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (2).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (3).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (4).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (5).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (6).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (7).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (8).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (9).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (10).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (11).jpg') },
      { image: require('@/assets/images/albums/goldenring/image (12).jpg') },
    ]
  },  
  abandoned: {
    title: 'AMAZING ABANDONED TIME-OUT',
    shortDescription: 'Preserved in time, this Time-Out in Roanoke Virginia was recently uncovered by construction workers tearing down a wall.',
    longDescription: `
      <p>ORIGINAL 80S TIME OUT ARCADE FOUND IN A DEAD MALL IN VIRGINIA</p>

      <p>Very cool article written by Cat DeSpira</p>
      
      <p>"Workmen ripping into a wall discovered the "buried remains" of Crossroads Mall's historic Time Out arcade, opened in 1978 and closed since approximately 1992, preserved in time."</p>
      
      <p><a href="https://retrobitch.wordpress.com/2017/12/12/original-80s-time-out-arcade-found-in-a-dead-mall-in-virginia/" target="_blank">Read full article</a></p>
    `,
    heroImage: require('@/assets/images/albums/abandoned/image (3).png'),
    slides: [
      { image: require('@/assets/images/albums/abandoned/image (1).png') },
      { image: require('@/assets/images/albums/abandoned/image (2).png') },
      { image: require('@/assets/images/albums/abandoned/image (3).png') },
      { image: require('@/assets/images/albums/abandoned/image (4).png') },
      { image: require('@/assets/images/albums/abandoned/image (5).png') },
    ]
  },
  dan_schopf: {
    title: 'TIME-OUT NEWSLETTERS',
    shortDescription: 'Dan Schopf was kind enough to mail these totally cool Time-Out newsletters to scan for the site. Included are several issues of "The Sound Board", Time-Out\'s employee newsletter, a sequence of company memos about holiday coupon book sales, and a Time-Out Holiday card.',
    longDescription: `
      <p>Dan Schopf was kind enough to mail me these totally cool Time-Out newsletters to scan for the site.</p>

      <p>Included are several issues of "The Sound Board", Time-Out's employee newsletter, a sequence of company memos about holiday coupon book sales, and a Time-Out Holiday card. The holiday card has a nice color photo of Dan and two employees at the entrance of his Time-Out at the Terrace Mall, Robbinsdale, MN (store #51).</p>
      
      <p>Contained in the newsletters are several cartoons and even a Time-Out crossword puzzle!</p>

      <p>
      Of the holiday photo, Dan says:<br>
      <i>"Took me a while, but I now remember the names of the others in the photo. From left to right: Dale Parvey, myself, and Gary Olson. Dale and I remained friends for a few years after Time Out. Gary (who's name I forgot) was very quite but was responsible for the idea of the Ms. Onion Peel stripper at a Mall Christmas party (it's in the news letter)".</i></p>
      
      <p>Dan Schopf is pictured, center, at the entrance of his Time-Out at the Terrace Mall, Robbinsdale, MN.</p>
      
      <p>Very cool Dan, thanks so much!</p>
    `,
    heroImage: require('@/assets/images/albums/dan_schopf/timeout_holiday_card.jpg'),
    slides: [
      { image: require('@/assets/images/albums/dan_schopf/timeout_holiday_card.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no3_p1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no3_p2.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no3_p3.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no3_p4.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no3_p5.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no3_p6.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p2.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p3.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p4.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p5.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p6.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p7.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/v1_no4_p8.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p2.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p3.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p4-5.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p6.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p7.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/sb_march83_p8.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/crosswordpuzzle.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/dec_15_1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/dec_15_2.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/dec1_1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/dec1_2.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/dec8_1.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/dec22_1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/dec22_2.jpg') },

      { image: require('@/assets/images/albums/dan_schopf/dec29_1.jpg') },
      { image: require('@/assets/images/albums/dan_schopf/dec29_2.jpg') },
    ]
  },  
  wayne_steeves: {
    title: 'MORE TIME-OUT NEWSLETTERS',
    shortDescription: 'Here\'s another Time-Out newsletter. This one is from 1985 and was sent by Wayne Steeves.',
    longDescription: `
      <p>Wayne Steeves contributed this Time-Out newsletter from March 1985. It's listed as Vol. 4, No.2.</p>
      <p>Wayne writes: <i>"Listed is a spotlight of region G. I worked at store #35 and #8 in Springfield Mall in the 11 years I worked for Time-Out. I'm in one of the pictures listed."<i></p>
      <p>Thanks Wayne!</p>
    `,
    heroImage: require('@/assets/images/albums/wayne_steeves/album.jpg'),
    slides: [
      { image: require('@/assets/images/albums/wayne_steeves/image (2).jpg') },
      { image: require('@/assets/images/albums/wayne_steeves/image (1).jpg') },
      { image: require('@/assets/images/albums/wayne_steeves/image (3).jpg') },
      { image: require('@/assets/images/albums/wayne_steeves/image (4).jpg') },
      { image: require('@/assets/images/albums/wayne_steeves/image (5).jpg') },
      { image: require('@/assets/images/albums/wayne_steeves/image (6).jpg') },
    ]
  },  
  invoices: {
    title: 'TIME-OUT INVOICES',
    shortDescription: 'Various sales invoices from Time-Out, Space Port, Fan Showcase, and Station Break arcades (these were all owned by Edison Brothers Mall Entertainment at the time). Invoices date from 1990 to 1993.',
    longDescription: `
      <p>Here are scans of some sales invoices donated to me by Lloyd Thoburn of <a href="coinopwarehouse.com" target="_blank">coinopwarehouse.com</a></p>
      <p>The sales invoices are from the "Time-Out", "Space Port", "Station Break", and "Fan Showcase" arcades. The invoices date from 1991 to 1993 and are from when Time-Out was owned by Edison Brothers. Edison Brothers owned all these arcades at one point.</p>
    `,
    heroImage: require('@/assets/images/albums/invoices/image (2).jpg'),
    slides: [
      { image: require('@/assets/images/albums/invoices/image (2).jpg') },
      { image: require('@/assets/images/albums/invoices/image (1).jpg') },
      { image: require('@/assets/images/albums/invoices/image (3).jpg') },
      { image: require('@/assets/images/albums/invoices/image (4).jpg') },
      { image: require('@/assets/images/albums/invoices/image (5).jpg') },
      { image: require('@/assets/images/albums/invoices/image (6).jpg') },
      { image: require('@/assets/images/albums/invoices/image (7).jpg') },
      { image: require('@/assets/images/albums/invoices/image (8).jpg') },
      { image: require('@/assets/images/albums/invoices/image (9).jpg') },
      { image: require('@/assets/images/albums/invoices/image (10).jpg') },
    ]
  },    
  springfield_trips: {
    title: 'MY TRIPS TO SPRINGFIELD MALL',
    shortDescription: 'My trips over the years to the Time-Out of my youth, Springfield Mall in Springfield, VA',
    longDescription: `
      My trips over the years to the Time-Out of my youth, Springfield Mall in Springfield, VA, starting with a trip in 2003, following by another trip in 2005, and ending with a final trip in 2017 to find the store was sadly gone.
    `,
    heroImage: require('@/assets/images/albums/springfield_trips/2003 (4).jpg'),
    slides: [
      { image: require('@/assets/images/albums/springfield_trips/2003 (4).jpg'), text: '2003 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2003 (3).jpg'), text: '2003 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2003 (5).jpg'), text: '2003 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2003 (1).jpg'), text: '2003 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2003 (2).jpg'), text: '2003 visit (downstairs arcade)' },

      { image: require('@/assets/images/albums/springfield_trips/2005 (2).jpg'), text: '2005 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2005 (3).jpg'), text: '2005 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2005 (4).jpg'), text: '2005 visit' },
      { image: require('@/assets/images/albums/springfield_trips/2005 (1).jpg'), text: '2005 visit' },

      { image: require('@/assets/images/albums/springfield_trips/2017 (1).jpg'), text: '2017 visit - gone' },
      { image: require('@/assets/images/albums/springfield_trips/2017 (2).jpg'), text: '2017 visit - gone' },
    ]
  },    
}